import { render, staticRenderFns } from "./AktTestings.vue?vue&type=template&id=28ce2302&scoped=true"
import script from "./AktTestings.vue?vue&type=script&lang=ts"
export * from "./AktTestings.vue?vue&type=script&lang=ts"
import style0 from "./AktTestings.vue?vue&type=style&index=0&id=28ce2302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce2302",
  null
  
)

export default component.exports